export default Object.freeze({
  AzureGraph: 1,
  OpenAI: 2,
  Google: 3,
  Api: 4,
  Database: 5,
  AzureGraphSharePoint: 6,
  Ftp: 7,
  LinkedIn: 8,
  WhatsAppBusiness: 9,
  SendGrid: 10,
  ModelContextProtocol: 11,
  MetaPages: 12,
  Smtp: 13,
  Twilio: 14,
  Sendblue: 15,
});
